import { useEffect, useState } from 'react';

/** Whether a CSS media query matches, following changes (window resized, rotated). */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() => typeof matchMedia === 'function' && matchMedia(query).matches);
  useEffect(() => {
    const list = matchMedia(query);
    const listener = () => setMatches(list.matches);
    listener();
    list.addEventListener('change', listener);
    return () => list.removeEventListener('change', listener);
  }, [query]);
  return matches;
}
